import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, vModelText as _vModelText, vModelSelect as _vModelSelect, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "container",
  style: {"margin-top":"80px","padding-top":"40px"}
}
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-lg-6" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { class: "text-dark" }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = { class: "text-dark" }
const _hoisted_8 = { class: "col-lg-6 text-right align-self-end" }
const _hoisted_9 = {
  type: "submit",
  class: "btn btn-success",
  style: {"padding":"0.7em 2em"},
  form: "scenarioSettings"
}
const _hoisted_10 = { class: "form-group" }
const _hoisted_11 = { class: "form-group" }
const _hoisted_12 = { class: "form-row" }
const _hoisted_13 = { class: "form-group col" }
const _hoisted_14 = { class: "form-row" }
const _hoisted_15 = { class: "form-group col" }
const _hoisted_16 = { class: "input-group" }
const _hoisted_17 = ["value"]
const _hoisted_18 = { class: "error" }
const _hoisted_19 = { class: "form-group col" }
const _hoisted_20 = { class: "input-group" }
const _hoisted_21 = ["value"]
const _hoisted_22 = { class: "error" }
const _hoisted_23 = { class: "form-row" }
const _hoisted_24 = { class: "form-group col" }
const _hoisted_25 = { class: "form-group col" }
const _hoisted_26 = { class: "input-group" }
const _hoisted_27 = ["value"]
const _hoisted_28 = { class: "table table-bordered table-hover" }
const _hoisted_29 = {
  style: {"width":"80px"},
  class: "text-center"
}
const _hoisted_30 = ["onClick"]

import { computed, onMounted, ref, watch, shallowReactive, type Ref } from 'vue'
    import { useRoute } from 'vue-router'

    import { Refresh } from '@browser/Browser'
    import CorporateNavigation from "@common/Components/CorporateNavigation.vue"
    import { MonthPickerDialogViewModel } from '@common/Components/MonthPickerDialog'
    import MonthPickerDialog from '@common/Components/MonthPickerDialog.vue'
    import { guid } from '@common/Guid'
    import { MonthYear, MonthYearHelpers } from '@common/types'

    import { useSettingsPageQueryV1 } from '@Quest/CorporateScenarios/queries-vue-composables'
    import { useCreateCorporateScenarioCommandV1, useUpdateCorporateScenarioCommandV1 } from '@Quest/CorporateScenarios/commands-vue-composables'
    import type { SettingsPageReadModel } from '@Quest/CorporateScenarios/readmodels'

    // ======================
    // Route
    // ======================

    
export default /*@__PURE__*/_defineComponent({
  __name: 'SettingsPage',
  setup(__props) {

    const route = useRoute()

    const workspaceId = computed(() => Number(route.params.workspaceId ?? 0))
    const strategyId = computed(() => String(route.params.strategyId ?? ''))
    const scenarioId = computed(() => route.params.scenarioId ? String(route.params.scenarioId) : null)

    // ======================
    // Query
    // ======================

    const {
        runSettingsPageQueryV1,
        modelSettingsPageQueryV1
    } = useSettingsPageQueryV1(workspaceId, strategyId, scenarioId)

    const rm = modelSettingsPageQueryV1 as Ref<SettingsPageReadModel | null>
    const portfolios = computed(() => rm.value?.Portfolios ?? [])
    const createdScenarioId = ref<string | null>(null)

    // ======================
    // Commands
    // ======================

    const {
        invokeCreateCorporateScenarioCommandV1,
        succeedCreateCorporateScenarioCommandV1
    } = useCreateCorporateScenarioCommandV1(workspaceId, strategyId)

    const {
        invokeUpdateCorporateScenarioCommandV1,
        succeedUpdateCorporateScenarioCommandV1
    } = useUpdateCorporateScenarioCommandV1(workspaceId, strategyId)


    // ======================
    // Local State (stable instances)
    // ======================

    const planningStartDateMonthPicker = shallowReactive(new MonthPickerDialogViewModel())
    const planningEndDateMonthPicker = shallowReactive(new MonthPickerDialogViewModel())
    const benefitsConfidenceDateMonthPicker = shallowReactive(new MonthPickerDialogViewModel())

    const planningStartDate = computed<MonthYear | null>({
        get: () => rm.value?.PlanningStartDate ?? null,
        set: (v) => { if (rm.value) rm.value.PlanningStartDate = v }
    })

    const planningEndDate = computed<MonthYear | null>({
        get: () => rm.value?.PlanningEndDate ?? null,
        set: (v) => { if (rm.value) rm.value.PlanningEndDate = v }
    })

    const benefitsConfidenceDate = computed<MonthYear | null>({
        get: () => rm.value?.BenefitsConfidenceDate ?? null,
        set: (v) => { if (rm.value) rm.value.BenefitsConfidenceDate = v }
    })
    

    // ======================
    // Derived
    // ======================

    const planningStartDateLabel = computed(() =>
        MonthYearHelpers.toMonthYearLongString(planningStartDate.value)
    )

    const planningEndDateLabel = computed(() =>
        MonthYearHelpers.toMonthYearLongString(planningEndDate.value)
    )

    const benefitsConfidenceDateLabel = computed(() =>
        MonthYearHelpers.toMonthYearLongString(benefitsConfidenceDate.value)
    )


    // ======================
    // Month Pickers
    // ======================

    function showPlanningStartDateMonthPicker()
    {
        planningStartDateMonthPicker.show(planningStartDate.value, "Start of the Planning horizon", true)
    }

    function showPlanningEndDateMonthPicker()
    {
        planningEndDateMonthPicker.show(planningEndDate.value, "End of the Planning horizon", true)
    }

    function showBenefitsConfidenceDateMonthPicker()
    {
        benefitsConfidenceDateMonthPicker.show(benefitsConfidenceDate.value, "End of benefits confidence", false)
    }


    // ======================
    // Save
    // ======================

    function handleSavePortfolioScenarioSettings()
    {
        if (!rm.value || !planningStartDate.value || !planningEndDate.value)
            return

        const portfolioIds = rm.value.Portfolios
            .filter(p => p.IsConnected === true)
            .map(p => p.PortfolioId)

        if (!scenarioId.value)
        {
            const id = guid()
            createdScenarioId.value = id

            invokeCreateCorporateScenarioCommandV1({
                Id: createdScenarioId.value,
                Name: rm.value.ScenarioName,
                Description: rm.value.Description,
                PlanningStartDate: planningStartDate.value,
                PlanningEndDate: planningEndDate.value,
                Denomination: rm.value.Denomination,
                ApplyBenefitsConfidenceFactor: rm.value.ApplyBenefitsConfidenceFactor,
                BenefitsConfidenceDate: benefitsConfidenceDate.value,
                PortfolioIds: portfolioIds
            })
        }
        else
        {
            invokeUpdateCorporateScenarioCommandV1({
                Id: scenarioId.value,
                Name: rm.value.ScenarioName,
                Description: rm.value.Description,
                PlanningStartDate: planningStartDate.value,
                PlanningEndDate: planningEndDate.value,
                Denomination: rm.value.Denomination,
                ApplyBenefitsConfidenceFactor: rm.value.ApplyBenefitsConfidenceFactor,
                BenefitsConfidenceDate: benefitsConfidenceDate.value,
                PortfolioIds: portfolioIds
            })
        }
    }


    // ======================
    // Lifecycle
    // ======================

    onMounted(() =>
    {
        document.title = "Enterprise Plan - Settings"
        runSettingsPageQueryV1()
    })


    // ======================
    // Command Success
    // ======================

    watch(succeedCreateCorporateScenarioCommandV1, (current, previous) =>
    {
        if (current && !previous && createdScenarioId.value)
        {
            location.href = `/#/enterprise-plan/portfolios/${workspaceId.value}/${strategyId.value}/${createdScenarioId.value}`
            createdScenarioId.value = null
        }
    })

    watch(succeedUpdateCorporateScenarioCommandV1, (current, previous) =>
    {
        if (current && !previous)
        {
            runSettingsPageQueryV1()
        }
    })

return (_ctx: any,_cache: any) => {
  const _directive_sanitizedHref = _resolveDirective("sanitizedHref")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(MonthPickerDialog, {
      viewModel: _unref(planningStartDateMonthPicker),
      onUpdateDate: _cache[0] || (_cache[0] = ($event: any) => (planningStartDate.value = $event))
    }, null, 8 /* PROPS */, ["viewModel"]),
    _createVNode(MonthPickerDialog, {
      viewModel: _unref(planningEndDateMonthPicker),
      onUpdateDate: _cache[1] || (_cache[1] = ($event: any) => (planningEndDate.value = $event))
    }, null, 8 /* PROPS */, ["viewModel"]),
    _createVNode(MonthPickerDialog, {
      viewModel: _unref(benefitsConfidenceDateMonthPicker),
      onUpdateDate: _cache[2] || (_cache[2] = ($event: any) => (benefitsConfidenceDate.value = $event))
    }, null, 8 /* PROPS */, ["viewModel"]),
    _createVNode(CorporateNavigation, { ActivePage: "dashboard" }),
    (_unref(rm))
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              (scenarioId.value)
                ? (_openBlock(), _createElementBlock("h6", _hoisted_4, [
                    _withDirectives((_openBlock(), _createElementBlock("a", _hoisted_5, [...(_cache[7] || (_cache[7] = [
                      _createElementVNode("i", {
                        class: "fa fa-angle-double-left",
                        "aria-hidden": "true"
                      }, null, -1 /* CACHED */),
                      _createTextVNode(" Back to plan ", -1 /* CACHED */)
                    ]))])), [
                      [_directive_sanitizedHref, `/#/enterprise-plan/portfolios/${workspaceId.value}/${strategyId.value}/${scenarioId.value}`]
                    ])
                  ]))
                : _createCommentVNode("v-if", true),
              (!scenarioId.value)
                ? (_openBlock(), _createElementBlock("h6", _hoisted_6, [
                    _withDirectives((_openBlock(), _createElementBlock("a", _hoisted_7, [...(_cache[8] || (_cache[8] = [
                      _createElementVNode("i", {
                        class: "fa fa-angle-double-left",
                        "aria-hidden": "true"
                      }, null, -1 /* CACHED */),
                      _createTextVNode(" Back to plans ", -1 /* CACHED */)
                    ]))])), [
                      [_directive_sanitizedHref, `/#/enterprise/planning/${workspaceId.value}/${strategyId.value}`]
                    ])
                  ]))
                : _createCommentVNode("v-if", true),
              _cache[9] || (_cache[9] = _createElementVNode("h1", { style: {"font-size":"2em","font-weight":"300","color":"#33475b","margin":"0"} }, "Enterprise plan settings", -1 /* CACHED */))
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("button", _hoisted_9, _toDisplayString(scenarioId.value ? 'Save changes' : 'Create plan'), 1 /* TEXT */)
            ])
          ]),
          _cache[23] || (_cache[23] = _createElementVNode("hr", null, null, -1 /* CACHED */)),
          _createElementVNode("form", {
            id: "scenarioSettings",
            onSubmit: _withModifiers(handleSavePortfolioScenarioSettings, ["prevent"])
          }, [
            _createElementVNode("div", _hoisted_10, [
              _cache[10] || (_cache[10] = _createElementVNode("label", null, "Name:", -1 /* CACHED */)),
              _withDirectives(_createElementVNode("input", {
                type: "text",
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(rm).ScenarioName) = $event)),
                class: "form-control",
                required: "",
                minlength: "2"
              }, null, 512 /* NEED_PATCH */), [
                [
                  _vModelText,
                  _unref(rm).ScenarioName,
                  void 0,
                  { trim: true }
                ]
              ])
            ]),
            _createElementVNode("div", _hoisted_11, [
              _cache[11] || (_cache[11] = _createElementVNode("label", null, "Description:", -1 /* CACHED */)),
              _withDirectives(_createElementVNode("textarea", {
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(rm).Description) = $event)),
                class: "form-control"
              }, null, 512 /* NEED_PATCH */), [
                [
                  _vModelText,
                  _unref(rm).Description,
                  void 0,
                  { trim: true }
                ]
              ])
            ]),
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("div", _hoisted_13, [
                _cache[13] || (_cache[13] = _createElementVNode("label", { for: "denomination" }, "Currency denomination:", -1 /* CACHED */)),
                _withDirectives(_createElementVNode("select", {
                  id: "denomination",
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_unref(rm).Denomination) = $event)),
                  class: "form-control"
                }, [...(_cache[12] || (_cache[12] = [
                  _createElementVNode("option", { value: "Unit" }, "Unit", -1 /* CACHED */),
                  _createElementVNode("option", { value: "Thousand" }, "Thousand", -1 /* CACHED */),
                  _createElementVNode("option", { value: "Million" }, "Million", -1 /* CACHED */)
                ]))], 512 /* NEED_PATCH */), [
                  [_vModelSelect, _unref(rm).Denomination]
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("div", _hoisted_15, [
                _cache[15] || (_cache[15] = _createElementVNode("label", null, "Planning from:", -1 /* CACHED */)),
                _createElementVNode("div", _hoisted_16, [
                  _createElementVNode("input", {
                    value: planningStartDateLabel.value,
                    type: "text",
                    class: "form-control pointer bg-white",
                    readonly: "",
                    onClick: showPlanningStartDateMonthPicker
                  }, null, 8 /* PROPS */, _hoisted_17),
                  _createElementVNode("div", { class: "input-group-append" }, [
                    _createElementVNode("button", {
                      class: "btn btn-outline-secondary",
                      type: "button",
                      onClick: showPlanningStartDateMonthPicker
                    }, [...(_cache[14] || (_cache[14] = [
                      _createElementVNode("i", {
                        class: "fa-regular fa-calendar",
                        "aria-hidden": "true"
                      }, null, -1 /* CACHED */)
                    ]))])
                  ])
                ]),
                _createElementVNode("div", _hoisted_18, _toDisplayString(_unref(rm).PlanningStartDateError), 1 /* TEXT */)
              ]),
              _createElementVNode("div", _hoisted_19, [
                _cache[17] || (_cache[17] = _createElementVNode("label", null, "Planning to:", -1 /* CACHED */)),
                _createElementVNode("div", _hoisted_20, [
                  _createElementVNode("input", {
                    value: planningEndDateLabel.value,
                    type: "text",
                    class: "form-control pointer bg-white",
                    readonly: "",
                    onClick: showPlanningEndDateMonthPicker
                  }, null, 8 /* PROPS */, _hoisted_21),
                  _createElementVNode("div", { class: "input-group-append" }, [
                    _createElementVNode("button", {
                      class: "btn btn-outline-secondary",
                      type: "button",
                      onClick: showPlanningEndDateMonthPicker
                    }, [...(_cache[16] || (_cache[16] = [
                      _createElementVNode("i", {
                        class: "fa-regular fa-calendar",
                        "aria-hidden": "true"
                      }, null, -1 /* CACHED */)
                    ]))])
                  ])
                ]),
                _createElementVNode("div", _hoisted_22, _toDisplayString(_unref(rm).PlanningEndDateError), 1 /* TEXT */)
              ])
            ]),
            _createElementVNode("div", _hoisted_23, [
              _createElementVNode("div", _hoisted_24, [
                _cache[19] || (_cache[19] = _createElementVNode("label", null, "Risk adjusted benefits:", -1 /* CACHED */)),
                _withDirectives(_createElementVNode("select", {
                  class: "form-control",
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_unref(rm).ApplyBenefitsConfidenceFactor) = $event))
                }, [...(_cache[18] || (_cache[18] = [
                  _createElementVNode("option", { value: true }, "Enabled", -1 /* CACHED */),
                  _createElementVNode("option", { value: false }, "Disabled", -1 /* CACHED */)
                ]))], 512 /* NEED_PATCH */), [
                  [_vModelSelect, _unref(rm).ApplyBenefitsConfidenceFactor]
                ])
              ]),
              _createElementVNode("div", _hoisted_25, [
                _cache[21] || (_cache[21] = _createElementVNode("label", null, "End of benefits confidence:", -1 /* CACHED */)),
                _createElementVNode("div", _hoisted_26, [
                  _createElementVNode("input", {
                    value: benefitsConfidenceDateLabel.value,
                    type: "text",
                    class: "form-control pointer bg-white",
                    readonly: "",
                    onClick: showBenefitsConfidenceDateMonthPicker
                  }, null, 8 /* PROPS */, _hoisted_27),
                  _createElementVNode("div", { class: "input-group-append" }, [
                    _createElementVNode("button", {
                      class: "btn btn-outline-secondary",
                      type: "button",
                      onClick: showBenefitsConfidenceDateMonthPicker
                    }, [...(_cache[20] || (_cache[20] = [
                      _createElementVNode("i", {
                        class: "fa-regular fa-calendar",
                        "aria-hidden": "true"
                      }, null, -1 /* CACHED */)
                    ]))])
                  ])
                ])
              ])
            ])
          ], 32 /* NEED_HYDRATION */),
          _cache[24] || (_cache[24] = _createElementVNode("hr", { class: "my-4" }, null, -1 /* CACHED */)),
          _cache[25] || (_cache[25] = _createElementVNode("h4", null, null, -1 /* CACHED */)),
          _createElementVNode("table", _hoisted_28, [
            _cache[22] || (_cache[22] = _createElementVNode("thead", null, [
              _createElementVNode("tr", { class: "table-secondary" }, [
                _createElementVNode("th", { colspan: "2" }, "Connected Portfolios")
              ])
            ], -1 /* CACHED */)),
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(portfolios.value, (p) => {
                return (_openBlock(), _createElementBlock("tr", {
                  key: p.PortfolioId
                }, [
                  _createElementVNode("td", _hoisted_29, [
                    _createElementVNode("a", {
                      class: _normalizeClass(p.IsConnected ? 'text-primary' : 'text-secondary'),
                      onClick: ($event: any) => (p.IsConnected = !p.IsConnected)
                    }, [
                      _createElementVNode("i", {
                        class: _normalizeClass(p.IsConnected ? 'fa-toggle-on fa fa-2xl fa-solid' : 'fa-toggle-off fa fa-2xl fa-solid')
                      }, null, 2 /* CLASS */)
                    ], 10 /* CLASS, PROPS */, _hoisted_30)
                  ]),
                  _createElementVNode("td", null, _toDisplayString(p.PortfolioName), 1 /* TEXT */)
                ]))
              }), 128 /* KEYED_FRAGMENT */))
            ])
          ])
        ]))
      : _createCommentVNode("v-if", true)
  ]))
}
}

})